import { bagFirstStage, bagRedeliverNeeded, BAG_FIRST_TEXT } from '../bagFirst';

// bag-first（2026-09-01）の「次のステップ」＋唯一のCTA（集荷を依頼する／バッグお届けを再依頼）。
// ホーム(Home.jsx)と注文詳細([id].jsx)で同じ表示・同じ判定になるよう共通化（2026-09-03）。
// お届け中は①だけが生きていて、到着すると①が済になり②③が生きる。
//   order            : bag_status 付きの注文（bagFirstStage(order) が '' なら何も描画しない）
//   onRequestPickup  : 「集荷を依頼する」押下（bag_status='arrived' のときだけ活性）
//   onRequestBagAgain: 「バッグお届けを再依頼」押下（配送が canceled/returned で戻ったときだけ表示）
//   isRequesting     : 二重送信防止
//   note             : CTA下の補足文（省略可）
export const BagFirstNext = ({ order, onRequestPickup, onRequestBagAgain, isRequesting, note }) => {
  const stage = bagFirstStage(order);
  if (!stage) return null;
  const bagArrived = stage === 'arrived';
  const bagRedeliver = bagRedeliverNeeded(order);
  return (
    <div className="mb-4">
      <div className="bf-todo">
        <div className="bf-todo_title">次のステップ</div>
        <div className={`bf-todo_step ${bagArrived ? 'is-done' : ''}`}>
          <span className="bf-todo_num">{bagArrived ? '✓' : '1'}</span>
          <span className="bf-todo_text">
            バッグを受け取る
            {!bagArrived && (
              <small className="bf-ng">※この配達員に依頼品は渡せません</small>
            )}
          </span>
        </div>
        <div className={`bf-todo_step ${bagArrived ? '' : 'is-off'}`}>
          <span className="bf-todo_num">2</span>
          <span className="bf-todo_text">
            依頼品(3点まで)をバッグに入れる
            {bagArrived && <small>Yシャツは2枚で1点カウント</small>}
          </span>
        </div>
        <div className={`bf-todo_step ${bagArrived ? '' : 'is-off'}`}>
          <span className="bf-todo_num">3</span>
          <span className="bf-todo_text">
            {bagArrived ? <b>集荷を依頼する</b> : '下のボタンから集荷を依頼する'}
            {bagArrived && <small>準備ができたら下のボタンをタップ</small>}
          </span>
        </div>
      </div>

      {bagRedeliver ? (
        <button className="button-next bf-cta" onClick={onRequestBagAgain} disabled={isRequesting}>
          {BAG_FIRST_TEXT.redeliver.cta}
        </button>
      ) : (
        <button
          className={`${bagArrived ? 'button-next' : 'button-next-g'} bf-cta`}
          onClick={onRequestPickup}
          disabled={!bagArrived || isRequesting}
        >
          {BAG_FIRST_TEXT[stage].cta}
        </button>
      )}

      {note && <div className="bf-note">{note}</div>}
    </div>
  );
};

export default BagFirstNext;
